import React, { useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import { useEffect } from 'react';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';

const PayHead = () => {
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    id: null,
    message: '',
});


    const [showForm, setShowForm] = useState(false);

    const [payHeadTable, setPayHeadTable] = useState([
        {
            id: 1,
            name: 'Employee1',
            order_no: 'HGT566YY66',
            club: 'Club1',
            type: 'Employee',
            employeeWise: false,
            addToGross: false,
            everyMonth: false,
            description: 'Basic salary component'
        }
    ]);

    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [detail, setDetail] = useState([]);

    const [formData, setFormData] = useState({
        name: '',
        payHeadCategory: '',
        // order_no: '',
        // club: '',
        type: '',
        // employeeWise: false,
        // addToGross: false,
        // everyMonth: false,
        description: ''
    });

    const [searchTerm, setSearchTerm] = useState('');

    //  Edit existing entry
    const handleEditClick = (item) => {
        setFormData({
            name: item.name,
            payHeadCategory: item.payHeadCategory || '',
            // order_no: item.order_no,
            // club: item.club,
            type: item.type,
            // employeeWise: item.employeeWise,
            // addToGross: item.addToGross,
            // everyMonth: item.everyMonth,
            description: item.description
        });
        setIsEditing(true);
        setEditingId(item.id);
        setShowForm(true);
    };

    //  Input handler for text/select/checkbox
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };



    // fetch from database
    const fetchPayheads = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-payhead');
            console.log(res.data.result);
            setDetail(res.data.result);
        } catch (error) {
            console.error('Error fetching Pay Heads:', error);
            setToast({ show: true, message: 'Failed to fetch Pay Heads', bg: 'danger' });
        }
    };  


    useEffect(() => {
        fetchPayheads();
    }, [])

    //  Save / Update
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {

            if (isEditing) {
                const res = await axios.put(`https://api.skyguard.group/api/update-payhead/${editingId}`, formData);

                setToast({
                    show: true,
                    message: 'Pay Head updated successfully!',
                    bg: 'success'
                });
                console.log("Server response", res.data.message);

                // Update table locally
                setPayHeadTable(prev =>
                    prev.map(item => item.id === editingId ? { id: editingId, ...formData } : item)
                );
            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-payhead', formData);

                setToast({
                    show: true,
                    message: 'Pay Head added successfully!',
                    bg: 'success'
                });
                // console.log("Server reponse", res.data.message);

                setPayHeadTable(prev => [
                    ...prev,
                    { id: res.data.insertId, ...formData }
                ]);
            }
            fetchPayheads();

            setFormData({
                name: '',
                // order_no: '',
                // club: '',
                type: '',
                // employeeWise: false,
                // addToGross: false,
                // everyMonth: false,
                description: ''
            });
            setIsEditing(false);
            setEditingId(null);
            setShowForm(false);

        } catch (error) {
            console.error(' Error adding Pay Head:', error);
            alert('Error adding Pay Head. Check console for details.');
        }
    }

    //  Add new
    const handleAddClick = () => {
        setFormData({
            name: '',
            // order_no: '',
            // club: '',
            type: '',
            // employeeWise: false,
            // addToGross: false,
            // everyMonth: false,
            description: ''
        });
        setIsEditing(false);
        setEditingId(null);
        setShowForm(true);
    };

    const clubOptions = [
        { value: 'Club 1', label: 'Club 1' },
        { value: 'Club 2', label: 'Club 2' },
        { value: 'Club 3', label: 'Club 3' }
    ];

    const typeOptions = [
        { value: 'Earning', label: 'Earning' },
        { value: 'Deduction', label: 'Deduction' }
    ];

    //  Delete
    // const handleDeletePayHead = async (idToDelete) => {
    //     if (!window.confirm("Are you sure you want to delete this Pay Head?")) return;

    //     try {
    //         const res = await axios.delete(`https://api.skyguard.group/api/delete-payhead/${idToDelete}`);
    //         setToast({
    //             show: true,
    //             message: 'Pay Head deleted successfully!',
    //             bg: 'success'
    //         });

    //         fetchPayheads();

    //         // Remove deleted item from local state
    //         setDetail(prev => prev.filter(item => item.id !== idToDelete));
    //     } catch (error) {
    //         console.error('Error deleting Pay Head:', error);
    //         setToast({
    //             show: true,
    //             message: 'Failed to delete Pay Head. Check console for details.',
    //             bg: 'danger'
    //         });
    //     }
    // };
// Delete using ConfirmDialog
const handleDeleteClick = (id, name) => {
    setConfirmDialog({
        show: true,
        id: id,
        message: `Are you sure you want to delete Pay Head "${name}"?`
    });
};

const confirmDelete = async () => {
    try {
        await axios.delete(`https://api.skyguard.group/api/delete-payhead/${confirmDialog.id}`);
        setToast({
            show: true,
            message: 'Pay Head deleted successfully!',
            bg: 'success'
        });

        // Update local state
        setDetail(prev => prev.filter(item => item.id !== confirmDialog.id));

    } catch (error) {
        console.error('Error deleting Pay Head:', error);
        setToast({
            show: true,
            message: 'Failed to delete Pay Head. Check console for details.',
            bg: 'danger'
        });
    } finally {
        setConfirmDialog({ show: false, id: null, message: '' });
    }
};


    return (
        <>
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Pay Head</h3>

                <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                    <div className="col-12 col-md-5">
                        <input
                            type="text"
                            className="form-control border-0 border-bottom border-dark"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="col-12 col-md-2 d-flex justify-content-end">
                        <button className='btn btn-success' onClick={handleAddClick}>
                            <AiOutlinePlusCircle size={20} /> Add
                        </button>
                    </div>
                </div>

                {/*  Form Section */}
                {showForm && (
                    <div className='card p-3 my-3 shadow-sm bg-white border'>
                        <div className='row'>

                           {isEditing && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.name}
    </span>
  </div>
)}                       
                            {/* left side */}
                            <div className='col-md-6'>
                                <div className='row g-3'>
                                    <div className="col-12">
                                        <label className="form-label fw-medium">Enter PayHead Name & Category</label>
                                        <div className="row g-2">
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="name"
                                                    placeholder="PayHead Name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <select
                                                    className="form-select"
                                                    name="payHeadCategory"
                                                    value={formData.payHeadCategory}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select...</option>
                                                    <option value="Variable">Variable</option>
                                                    <option value="Fixed">Fixed</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col-12">
                                        <label className="form-label fw-medium">Enter Order</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="order_no"
                                            value={formData.order_no}
                                            onChange={handleChange}
                                        />
                                    </div> */}
                                    {/* <div className="col-12">
                                        <label className="form-label fw-medium">Select Club To</label>
                                        <Select
                                            options={clubOptions}
                                            value={clubOptions.find(option => option.value === formData.club)}
                                            onChange={(selected) =>
                                                setFormData(prev => ({ ...prev, club: selected.value }))
                                            }
                                        />
                                    </div> */}
                                    <div className="col-12">
                                        <label className="form-label fw-medium">Select Type</label>
                                        <Select
                                            options={typeOptions}
                                            value={typeOptions.find(option => option.value === formData.type)}
                                            onChange={(selected) =>
                                                setFormData(prev => ({ ...prev, type: selected.value }))
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* right side */}
                            <div className='col-md-6'>
                                <div className='row g-3'>
                                    {/* <div className="col-12">
                                        <label className="form-label fw-medium">Options</label>
                                        <div className='card p-3 border'>
                                            <div className="form-check mt-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="employeeWise"
                                                    checked={formData.employeeWise}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label">Employee Wise</label>
                                            </div>
                                            <div className="form-check mt-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="addToGross"
                                                    checked={formData.addToGross}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label">Add to Gross</label>
                                            </div>
                                            <div className="form-check mt-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="everyMonth"
                                                    checked={formData.everyMonth}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label">Every Month</label>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className='col-12'>
                                        <label htmlFor="description" className='form-label fw-medium'>Calculate On</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            name="description"
                                            rows="5"
                                            placeholder="Enter here..."
                                            value={formData.description}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex justify-content-end mt-4 gap-2'>
                            <button type='button' className='btn btn-success' onClick={handleSubmit}>
                                {isEditing ? 'Update' : 'Save'}
                            </button>
                            <button type='button' className='btn btn-danger' onClick={() => setShowForm(false)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {/*  Table Section */}
                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped text-center table-sm align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th>SN</th>
                                  <th>Action</th>
                                <th>Name</th>
                                <th>Category</th>
                                {/* <th>Order</th> */}
                                {/* <th>Club To</th> */}
                                <th>Type</th>
                                {/* <th>Emp Wise</th>
                                <th>Add to Gross</th>
                                <th>Every Month</th> */}
                              
                            </tr>
                        </thead>
                        <tbody className='table-sm'>
                            {detail.filter(itm =>
                                Object.values(itm).some(val =>
                                    String(val).toLowerCase().includes(searchTerm.toLowerCase())
                                )
                            ).length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="text-center text-muted py-1 small">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                detail
                                    .filter(itm =>
                                        Object.values(itm).some(val =>
                                            String(val).toLowerCase().includes(searchTerm.toLowerCase())
                                        )
                                    )
                                    .map((itm, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                                                                     <td>
    <button
        className='btn btn-primary mx-1'
        onClick={() => handleEditClick(itm)}
    >
        <AiOutlineEdit size={18} />
    </button>
    <button
        className='btn btn-danger'
        onClick={() => handleDeleteClick(itm.id, itm.name)}
    >
        <AiOutlineDelete size={18} />
    </button>
</td>

                                            <td>{itm.name}</td>
                                            <td>{itm.payHeadCategory}</td>
                                            {/* <td>{itm.order_no}</td> */}
                                            {/* <td>{itm.club}</td> */}
                                            <td>{itm.type}</td>
                                            {/* <td>{itm.employeeWise ? <AiOutlineCheck color="green" size={28} /> : <AiOutlineClose color="red" size={28} />}</td>
                                            <td>{itm.addToGross ? <AiOutlineCheck color="green" size={28} /> : <AiOutlineClose color="red" size={28} />}</td>
                                            <td>{itm.everyMonth ? <AiOutlineCheck color="green" size={28} /> : <AiOutlineClose color="red" size={28} />}</td> */}
  
                                        </tr>
                                    ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
         <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast((prev) => ({ ...prev, show: false }))}
      />
      <ConfirmDialog
    show={confirmDialog.show}
    message={confirmDialog.message}
    onConfirm={confirmDelete}
    onCancel={() => setConfirmDialog({ show: false, id: null, message: '' })}
/>

        </>
    );
};

export default PayHead;